import config from '@/config'
import {
  runQuery,
  runMutation
} from '../graphQl'
import * as workflowQuery from '../query/workflow'
// import Config from '../../config.js'
import store from '@/store/index.js'
import http from '../http'
import { getworkflowEscalationHistoryQuery } from '../query/workflows'

export const GetAllWorkflowByVersionById = (versionId, tokenType = 'tenant') => {
  return runQuery(workflowQuery.GetAllWorkflowByVersionByIdQuery(), { id: versionId }, tokenType)
}
export const CreateWorkflowTemplateWIthPhases = (data, tokenType = 'tenant') => {
  return runQuery(workflowQuery.CreateWorkflowTemplateWIthPhasesMutation(), { data }, tokenType)
}
export const GetWorkflowTypes = (tokenType = 'tenant') => {
  return runQuery(workflowQuery.GetWorkflowTypesQuery(), { }, tokenType)
}
export const CreateWorkflowSteps = (data, tokenType = 'tenant') => {
  return runQuery(workflowQuery.CreateWorkflowStepsMutation(), { data }, tokenType)
}
export const CreateWorkflowTransition = (data, tokenType = 'tenant') => {
  return runQuery(workflowQuery.CreateWorkflowTransitionMutation(), { data }, tokenType)
}
export const getAllWorkFLowTemplatesWithPagination = (limit, pageNo, searchKeyword = '', tokenType = 'tenant', sorting) => {
  let orderBy = { created_on: 'desc' }
  if (sorting === '2') {
    orderBy = { created_on: 'asc' }
  } else if (sorting === '3') {
    orderBy = { name: 'asc' }
  } else if (sorting === '4') {
    orderBy = { name: 'desc' }
  } else orderBy = { created_on: 'desc' }
  return runQuery(workflowQuery.getWorkFLowTemplatesQuery(), { limit, offset: (pageNo - 1) * limit, searchKeyword: `%${searchKeyword}%`, orderBy }, tokenType)
}
// with out pagination
export const getFullWorkFLowTemplates = (featureIds = [], searchKeyWord = '', categoryIds = []) => {
  const conditions = { tenant_id: { _is_null: false } }
  if (featureIds.length) {
    conditions.feature_id = { _in: featureIds }
  }
  if (categoryIds.length) {
    conditions.category = { _in: categoryIds }
  }
  if (searchKeyWord?.length) {
    conditions.name = { _ilike: `%${searchKeyWord}%` }
  }
  return runQuery(workflowQuery.getfullWorkFLowTemplatesQuery(), { conditions }, 'tenant')
}
export const GetWorkFlowDataByTemplateId = (templateId, tokenType = 'tenant') => {
  return runQuery(workflowQuery.GetWorkFlowDataByTemplateIdQuery(), { id: templateId }, tokenType)
}
export const updateWorkFlowTemplate = (draft, templateId, updates, tokenType = 'tenant') => {
  return runMutation(workflowQuery.updateWorkFlowTemplateMutaion(), { draft, templateId, updates }, tokenType)
}
export const InsertValidation = (object, tokenType = 'tenant') => {
  console.log(object, 'this is the object')
  return runMutation(workflowQuery.InsertValidationMutation(), { object }, tokenType)
}
export const UpdateWorkflowTemplateNameOrObjective = (id, templateName = undefined, objective = undefined, tokenType = 'tenant') => {
  if (!templateName && !objective) {
    return
  }
  const payload = { }
  if (templateName) {
    payload.name = templateName
  }
  if (objective) {
    payload.objective = objective
  }
  return runMutation(workflowQuery.UpdateWorkflowTemplateNameMutation(), { id, payload }, tokenType)
}
export const workflowDataBasedOnInstanceId = (id, isExternalCollaborator = false) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.workflowDataBasedOnInstanceIdQuery(), { id }, tokenType)
}

export const updateWorkFlowActionApi = async (body) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return http.POST(config.serverEndpoint + '/workflows/history', body, tokenType)
}

export const getTransitionData = (transitionId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.getTransitionDataQuery(), { transitionId }, tokenType)
}
export const getNextStepWithTransitionId = (transitionId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.getNextStepWithTransitionIdQuery(), { id: transitionId }, tokenType)
}
export const getworkflowEscalationHistory = (stepId, wfInstanceId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(getworkflowEscalationHistoryQuery(), { stepId, wfInstanceId }, tokenType)
}

export const getAlternateMaterialWorkflow = () => {
  return runQuery(workflowQuery.getAlternateMaterialWorkflowQuery(), {}, 'tenant')
}

export const getWorkflowDashbordData = (userId, type, isOnProjectLevel = false, workflowType = '', alternateMaterialWorkflowId, skipFetchingMaterialVendors = false, sorting = null) => {
  const conditions = {}
  const today = new Date()
  const nextWeek = new Date()
  nextWeek.setDate(today.getDate() + 7)
  const orderBy = [
    {
      workflow_instance_id: 'asc'
    }]
  const distinctOn = [
    'workflow_instance_id'
  ]
  const formatDate = (date) => date.toISOString().split('T')[0]
  if (sorting?.field && sorting?.direction) {
    orderBy.unshift({ [sorting.field]: sorting.direction })
    distinctOn.unshift(sorting.field)
  }
  if (!store.getters?.isTenantAdmin) {
    conditions.user_id = { _eq: userId }
  }
  conditions.is_current = { _eq: true }
  conditions.workflow_instance = {
    state_value: {
      name: {
        _eq: 'ONGOING'
      }
    }
  }
  if (store.getters?.collaborator) {
    conditions.tenant_id = { _eq: store.getters?.collaboratorId }
  }
  const materialConditions = {
    ...conditions,
    feature_id: {
      _eq: config.CORE_FEATURES.MATERIAL
    },
    category: {
      _in: [config.WORKFLOW_TYPES_INVERTED.LIFECYCLE]
    }
  }
  if (!store.getters?.collaborator && store.getters?.isTenantAdmin) {
    materialConditions.category._in.push(config.WORKFLOW_TYPES_INVERTED.ALTERNATE_MATERIAL)
  }
  materialConditions.user_id = undefined
  const formConditions = {
    ...conditions,
    feature_id: {
      _eq: config.CORE_FEATURES.FORMS
    },
    category: {
      _eq: config.WORKFLOW_TYPES_INVERTED.FORM_PROCESS
    }
  }
  const bomConditions = {
    ...conditions,
    feature_id: {
      _eq: config.CORE_FEATURES.BOM
    },
    category: {
      _eq: config.WORKFLOW_TYPES_INVERTED.LIFECYCLE
    }
  }
  const tenantConditions = {
    ...conditions,
    feature_id: {
      _eq: config.CORE_FEATURES.TENANT
    },
    category: {
      _eq: config.WORKFLOW_TYPES_INVERTED.TENANT_APPROVAL
    }
  }
  tenantConditions.user_id = undefined
  const documentConditions = {
    is_current: {
      _eq: true
    },
    workflow_instance: {
      state_value: {
        name: {
          _eq: 'ONGOING'
        }
      }
    },
    feature_id: {
      _eq: config.CORE_FEATURES.DOCUMENTS
    },
    category: {
      _in: [3, 4]
    }
  }
  switch (workflowType) {
  case 'material':
    conditions.feature_id = {
      _eq: config.CORE_FEATURES.MATERIAL
    }
    conditions.category = {
      _in: [config.WORKFLOW_TYPES_INVERTED.ALTERNATE_MATERIAL, config.WORKFLOW_TYPES_INVERTED.LIFECYCLE]
    }
    if (!store.getters?.collaborator && store.getters?.isTenantAdmin) {
      conditions.category._in.push(config.WORKFLOW_TYPES_INVERTED.ALTERNATE_MATERIAL)
    }
    conditions.user_id = undefined
    break
  case 'form':
    conditions.feature_id = {
      _eq: config.CORE_FEATURES.FORMS
    }
    conditions.category = {
      _eq: config.WORKFLOW_TYPES_INVERTED.FORM_PROCESS
    }
    break
  case 'vendor':
    conditions.feature_id = {
      _eq: config.CORE_FEATURES.TENANT
    }
    conditions.category = {
      _eq: config.WORKFLOW_TYPES_INVERTED.TENANT_APPROVAL
    }
    conditions.user_id = undefined
    break
  case 'document':
    Object.keys(conditions).forEach(key => delete conditions[key])
    Object.assign(conditions, documentConditions)
    break
  case 'bom':
    conditions.feature_id = {
      _eq: config.CORE_FEATURES.BOM
    }
    conditions.category = {
      _eq: config.WORKFLOW_TYPES_INVERTED.LIFECYCLE
    }
    break
  }
  const upcomingConditions = { ...conditions, is_current: { _eq: false }, planned_start_date: { _gte: formatDate(today), _lte: formatDate(nextWeek) } }
  return runQuery(workflowQuery.getDashboardDataQuery(),
    {
      conditions,
      materialConditions,
      formConditions,
      documentConditions,
      bomConditions,
      tenantConditions,
      upcomingConditions,
      orderBy,
      distinctOn
    }, isOnProjectLevel ? 'project' : 'tenant')
}

export const CheckIfUserGroupIsAttachedToWorkflow = (id) => {
  return runQuery(workflowQuery.CheckIfUserGroupIsAttachedToWorkflowQuery(), { id }, 'tenant')
}

export const getAllStepDocsExceptGivenStep = ({ currentStepId, instanceId }) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.getAllStepDocsExceptGivenStepQuery(), { currentStepId, instanceId }, tokenType)
}

export const startMaterialWorkflow = (workflowData, formId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.startMaterialWorkflowMutation(), { workflowData, formId }, tokenType)
}

export const GetJobOrderMaterialLinksInst = (formId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.GetJobOrderMaterialLinksQuery(), { formId }, tokenType)
}
export const getformsDataByWFstepIdAndInstanceId = (stepId, instanceId) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.getformsDataByWFstepIdAndInstanceIdQuery(), { stepId, instanceId }, tokenType)
}

export const getLastStepHistoryData = (id) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) {
    tokenType = 'project'
  }
  return runQuery(workflowQuery.getLastStepHistoryDataQuery(), { id }, tokenType)
}

export const getStartigStepsForInviteTenantWf = () => {
  const payload = { templateName: config.DEFAULT_TENANT_APPROVAL_WORKFLOW, featureId: config.CORE_FEATURES.TENANT, tenantId: store.getters.openTenantId }
  return runQuery(workflowQuery.getStartigStepsForInviteTenantWfQuery(), payload, 'tenant')
}

export const getResources = () => {
  return runQuery(workflowQuery.getMaterialResource(), {}, 'tenant')
}
export const getCorefeatureAndCategoryApi = () => {
  return runQuery(workflowQuery.getCorefeatureAndCategoryApiQuery(), {}, 'tenant')
}
// this query onlly returs basic data
export const getworkflowInstanceBasicData = (id) => {
  return runQuery(workflowQuery.getworkflowInstanceBasicDataQuery(), { id }, 'tenant')
}
